import reducer from './reducer';
import * as recorderActions from './action';

export interface recorderStateType{
    recorder: any
}

export {
    recorderActions,
};  

export default reducer;